import { type BackendErrorEntity, type BackendErrorMessageEntity, BackendErrorCode } from '~/apiClient';

const BACKEND_ERROR_CODES = new Set<string>(Object.values(BackendErrorCode));

const isBackendErrorMessage = (value: unknown): value is BackendErrorMessageEntity =>
    typeof value === 'object' && value !== null && 'code' in value && typeof value.code === 'string' && BACKEND_ERROR_CODES.has(value.code);

export default function (data: unknown): data is BackendErrorEntity {
    if (typeof data !== 'object' || data === null || !('error' in data)) return false;

    return isBackendErrorMessage(data.error);
}
